import { Injectable } from '@angular/core';
import { NotificationService } from 'src/app/features/notifications/notification.service';
import { MessageService } from './message.service';
import { UserStatusService } from './user-status.service';
import { PostHubService } from './post-hub.service';

@Injectable({ providedIn: 'root' })
export class HubManagerService {
  constructor(
    private userStatusService: UserStatusService,
    private messageService: MessageService,
    private notificationService: NotificationService,
    private postHubService: PostHubService,
  ) {}

  startAll() {
    return Promise.all([
      this.userStatusService.start(),
      this.messageService.start(),
      this.notificationService.start(),
      this.postHubService.start()
    ]);
  }

  stopAll() {
    return Promise.all([
      this.userStatusService.stop(),
      this.messageService.stop(),
      this.notificationService.stop(),
      this.postHubService.stop()
    ]);
  }
}
